export default __webpack_public_path__ + "static/media/double-swipe.65969b4d.png";